import axios from '@/api/config';

const liveLog = {
    pageList(data) {
        return axios.post(`${process.env.BASE_URL}/liveLog/pageList`, data);
    },
    recordPageList(data) {
        return axios.post(`${process.env.BASE_URL}/liveLog/recordPageList`, data);
    },
    enterCoursePageList(data) {
        return axios.post(`${process.env.BASE_URL}/liveLog/enterCoursePageList`, data);
    },
    liveDetail(data) {
        return axios.post(`${process.env.BASE_URL}/polyvChannel/queryChannelDuration`, data);
    },
    // 查询频道观看日志
    viewLogPageV2(data) {
        return axios.post(`${process.env.BASE_URL}/polyv/viewLogPage_v2`, data);
    },
    // 直播概况
    channelPlaySummaryV2(data) {
        return axios.post(`${process.env.BASE_URL}/polyv/channelPlaySummary_v2`, data);
    },
}

export default liveLog;


// WEBPACK FOOTER //
// ./src/api/liveLog.js